import React from 'react';
import styled, { StyledComponent } from '@emotion/styled';
import { WThemeAPIView } from './mockData/theme_styles/types';

type ThemeContextType = {
  components: {
    H1: StyledComponent<React.HTMLAttributes<HTMLHeadingElement>>;
    H2: StyledComponent<React.HTMLAttributes<HTMLHeadingElement>>;
    H3: StyledComponent<React.HTMLAttributes<HTMLHeadingElement>>;
    H4: StyledComponent<React.HTMLAttributes<HTMLHeadingElement>>;
    P: StyledComponent<React.HTMLAttributes<HTMLParagraphElement>>;
    Button: StyledComponent<React.ButtonHTMLAttributes<HTMLButtonElement>>;
  };
  highlightedComponents: string[];
} & Pick<WThemeAPIView, 'header' | 'light_or_dark' | 'background' | 'homepage' | 'container'>;

const BASE_FONT_VIEW = {
  font_family: 'Proxima Nova',
  font_color: 'black',
  font_size: 16,
  font_weight: 400,
  line_height: '1.2',
};

export const ThemeContext = React.createContext<ThemeContextType>({
  components: {
    H1: styled.h1``,
    H2: styled.h2``,
    H3: styled.h3``,
    H4: styled.h4``,
    P: styled.p``,
    Button: styled.button``,
  },
  header: { nav_item: { font: BASE_FONT_VIEW } },
  light_or_dark: 'light',
  background: {},
  homepage: {
    display_type: 'DISPLAY_TYPE_1',
    hero: {
      display_type: 'DISPLAY_TYPE_1',
    },
    name: {
      display_type: 'DISPLAY_TYPE_1',
    },
    date_location: {
      display_type: 'DISPLAY_TYPE_1',
    },
  },
  highlightedComponents: [],
});
